import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';

const TextFieldInput = ({ name, fieldName, control, props, valueAsNumber, ...rest }) => {
    const classes = useReactHookFormStyles();

    const {
        formState: { errors },
        getValues,
        updateSelectedValues,
    } = useFormContext();

    // if name is dot notation for nested values, access the nested value on the error object
    const nestedName = name.split('.');
    // by default use errors[name]
    const error = errors[name] || (nestedName.length && nestedName.reduce((acc, key) => acc?.[key], errors));

    return (
        <FormControl className={classes.formController}>
            <Controller
                name={name}
                control={control}
                shouldUnregister={props?.shouldUnregister}
                render={({ field: { onChange, value, ...controllerField } }) => (
                    <TextField
                        type={rest.type}
                        value={value === 0 ? value : value || null}
                        onChange={(event) => {
                            const val = valueAsNumber ? parseFloat(event.target.value) : event.target.value;
                            onChange(val === 0 ? val : val || null);
                            const fieldArrayValue = getValues(fieldName);
                            updateSelectedValues(fieldName, fieldArrayValue);
                        }}
                        InputLabelProps={{ shrink: true }}
                        style={{ width: '100%', ...rest.style }}
                        {...controllerField}
                        error={!!error}
                        required={rest.required}
                        label={rest.label}
                        helperText={error?.message || ''}
                        {...props}
                        {...rest}
                    />
                )}
            />
        </FormControl>
    );
};

export default TextFieldInput;
